import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.scss']
})
export class ImpersonateComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    sessionStorage.setItem('userToken', JSON.stringify({token: this.route.snapshot.queryParams.token}));
    setTimeout(() => {
      this.router.navigate(['/']);
    }, 100);
  }

}
